import Cross from './cross.svg?react';
import ResidentialProxy from './residential-proxy.svg?react';
import MobileProxy from './mobile-proxy.svg?react';
import DatacenterProxy from './datacenter-proxy.svg?react';
import ISPProxy from './isp-proxy.svg?react';
import Stripe from './stripe.svg?react';
import CardVisa from './card-visa.svg?react';
import CardMastercard from './card-mastercard.svg?react';
import CardAmex from './card-amex.svg?react';
import CurrencyBitcoin from './currency-btc.svg?react';
import CurrencyTether from './currency-tether.svg?react';
import CurrencyLitecoin from './currency-litecoin.svg?react';
import Copy from './copy.svg?react';

const Icon = {
  Cross,
  ResidentialProxy,
  MobileProxy,
  DatacenterProxy,
  ISPProxy,
  Stripe,
  CardVisa,
  CardMastercard,
  CardAmex,
  CurrencyBitcoin,
  CurrencyTether,
  CurrencyLitecoin,
  Copy,
};

export default Icon;
